module.exports = __webpack_public_path__ + "static/img/failed.a8f753ab.webp";